module.exports = __webpack_public_path__ + "media/pt_br_s2_Marcia.a6a7b64d.oga";